import type { PrivateEventDetail } from '../../api/privateEvents';

import {
  EMPTY_FIELDS,
  type PrivateEventFormFields,
  type PrivateEventLocationMode,
} from './private-event-form-state';

const MODE_BY_KIND: Record<PrivateEventDetail['locationKind'], PrivateEventLocationMode> = {
  venue: 'venue',
  client_site: 'client-site',
  tbd: 'tbd',
  unrecorded: 'tbd',
};

const blank = (value: string | null) => value ?? '';

/** "2099-11-12T18:00:00.000" → date and clock, read off the string: parsing it
 *  would apply the browser's zone to a venue wall clock. */
function splitWallClock(value: string | null): { date: string; time: string } {
  const [date = '', time = ''] = (value ?? '').split('T');
  return { date, time: time.slice(0, 5) };
}

/**
 * The When & what form's values for an event. The stored zone is seeded as a
 * manual pick so the default-zone logic never changes a confirmed zone on
 * mount, and a missing region or zone stays empty rather than being guessed.
 */
export function seedWhenWhat(event: PrivateEventDetail): PrivateEventFormFields {
  const start = splitWallClock(event.localStartsAt);
  const end = splitWallClock(event.localEndsAt);
  return {
    ...EMPTY_FIELDS,
    regionId: blank(event.regionId),
    locationMode: MODE_BY_KIND[event.locationKind],
    venueId: blank(event.venueId),
    locationName: blank(event.locationName),
    addressLine1: blank(event.addressLine1),
    addressLine2: blank(event.addressLine2),
    city: blank(event.city),
    state: blank(event.state),
    zipCode: blank(event.zipCode),
    timeZone: blank(event.timeZone),
    timeZoneSource: event.timeZone ? 'manual' : 'default',
    workshopTypeId: event.workshopTypeId,
    date: start.date,
    startTime: start.time,
    endDate: end.date,
    endTime: end.time,
    headcount: String(event.headcount),
  };
}
